import { render } from "./PageThankYou.vue?vue&type=template&id=ef6e7b8a"
import script from "./PageThankYou.vue?vue&type=script&lang=js"
export * from "./PageThankYou.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__